import type { TypeActivities } from '@router/stackflow';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

function useAuthFlow(flows?: {
    activityName: keyof TypeActivities,
    activityParams: object,
}[]) {
    const [_, setCookie, removeCookie] = useCookies(['authFlow']);
    useEffect(() => {
        if (flows) {
            setCookie('authFlow', JSON.stringify(flows), { path: '/', maxAge: 60 * 60 });
        } else {
            removeCookie('authFlow');
        }
    }, [flows]);
}

export default useAuthFlow;
